/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type LifeStyleAmountAmountType = (typeof LifeStyleAmountAmountType)[keyof typeof LifeStyleAmountAmountType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LifeStyleAmountAmountType = {
  vacation: "vacation",
  hobbies: "hobbies",
  entertainment: "entertainment",
  sport: "sport",
  health: "health",
  other: "other",
} as const;
